import IDataFilterHandler from "./IDataFilterHandler";
import { store } from "infrastructure/store/ConfigureStore";
import DataFilterBaseHandler from "./DataFilterBaseHandler";
import { injectable } from "inversify";
import {
  setGridUrlParams,
  resetGridPaginationUrlParams,
  resetGridUrlParams,
} from "infrastructure/store/dataGrid/DataGridActions";

@injectable()
export default class DataFilterHandler
  extends DataFilterBaseHandler
  implements IDataFilterHandler {
  
  storeDataGridSettings(dataGridId: string, params: URLSearchParams): void {
    params.delete("PageSize");

    // Update filtru
    store.dispatch(
      setGridUrlParams({ key: dataGridId, value: params.toString() })
    );

    // Update strankovani
    store.dispatch(resetGridPaginationUrlParams(dataGridId));
  }

  storeResetDataGridSettings(dataGridId: string): void {
    // Reset  stránkování
    store.dispatch(resetGridPaginationUrlParams(dataGridId));

    // Reset filtru
    store.dispatch(resetGridUrlParams(dataGridId));
  }
}